<template>
    <section v-if="display" class="zygote-rationale">
        <div v-if="answer" class="answer">Correct Answer: {{ answer }}</div>
        <div v-for="child of configuration.component_children" :key="child.component_id">
            <components v-if="child.component_type !== 'string'" :configuration="child" v-bind="child.component_data" />
            <template v-else>{{ child.component_content.trim() }}</template>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ZygoteRationale',
    props: {
        id: String,
        configuration: Object,
        display: false,
        answer: String,
    },
    methods: {
    }
}
</script>

<style lang="less">
@import "~@/assets/less/variables";

.zygote-rationale {
    background: fade(@green, 40%);
    color: @f;
    border-bottom-color: @green;
    border-radius: 3px;
    border: 1px solid #444;
    margin: 5px;
    padding-bottom: 20px;
    transition: border-color ease 0.2s;
}

.answer {
    padding-top: 10px;
    text-align: center;
}
</style>
